export const apiPath = '/rails/active_storage'
